import { AutoForm, SubmitField } from 'uniforms-bootstrap3';
import React, { PropTypes } from 'react';
import _ from 'lodash';

const MgfForm = parent => class extends parent {

    static MgfForm = MgfForm;

    static displayName = `MgfForm${parent.displayName}`;

	static defaultProps = {
		...parent.defaultProps,

		doSave: true, 	
	};

	static propTypes = {
		...parent.propTypes,

		doSave: PropTypes.oneOfType([PropTypes.bool]),
		collection: PropTypes.oneOfType([PropTypes.object]),
	};

	constructor() {
		super(...arguments);

		this.onSubmitSuccess = this.onSubmitSuccess.bind(this);
		this.onSubmitFailure = this.onSubmitFailure.bind(this);
	}

	getNativeFormProps () {
		const {
			doSave, 
			collection,

			...props
		} = super.getNativeFormProps();

		return props;
	}

    getModel(mode) {
		if (mode === 'submit') {
			const doc  = super.getModel('submit');
			const keys = _.without(this.getChildContextSchema().getSubfields(), 'createdAt', 'updatedAt');

			const update = keys.filter(key => doc[key] !== undefined);
			const remove = keys.filter(key => doc[key] === undefined);

			const $set   = update.reduce((acc, key) => ({...acc, [key]: doc[key]}), {});
			const $unset = remove.reduce((acc, key) => ({...acc, [key]: ''}), {});

			return {$set, $unset};
		}

		return super.getModel(mode);
    }

	getSubmitField() {
		const text = this.props.model && this.props.model['_id'] ? "Editer" : "Créer";

		return props =>
		    <SubmitField value={text} />; 
		
	}

	onSubmit(event) {
		if (event) {
			event.preventDefault();
			event.stopPropagation();
		}
			
		return new Promise((resolve) => { /* validating form */
				this.setState({validate: true}, () => {
					resolve(this.onValidate());
				});
			})
			.then((doc) => { /* saving resource */
				return new Promise((resolve, reject) => {
					const doc = this.getModel('submit');
					if (this.props.collection && this.props.doSave) {
						if(this.props.model['_id']) {
							this.props.collection.update({_id: this.props.model ? this.props.model['_id'] : null }, doc,
							(err, nb) => {
								err ? reject(err) : resolve(doc);
							});
						} else {
							let insert = doc.$set;
							this.props.collection.insert(insert,
								(err, nb) => {
									err ? reject(err) : resolve(doc);
							});
						}
					} else {
						return resolve(this.getModel('form'));
					}
				});
			})
			.then((doc) => { /* call supplied handler */
				return Promise.resolve(
					this.props.onSubmit &&
						this.props.onSubmit(this.getModel('form'))
				);
			})
			.then(this.onSubmitSuccess)
			.catch(this.onSubmitFailure);
	}
	
	onSubmitSuccess(doc) {
		Messenger().post({
			message: ((this.props.collection && this.props.collection.label) ? this.props.collection.label : "La resource") + " a été " + (this.props.model && this.props.model['_id'] ? "modifié" : "ajouté") + " avec succès.",
			type: "success"
		});
		
		return this.props.onSubmitSuccess ? this.props.onSubmitSuccess(doc) : doc;
	}
	
	onSubmitFailure(err) {
		console.error(err);
		if (err)
			Messenger().post({
				message: err,
				type: "error"
			});

		return this.props.onSubmitFailure ? this.props.onSubmitFailure(err) : err;
	}
};

// Now we have to inject our functionality. This one is a ModifierForm. Use any
// form component you want.
export default MgfForm(AutoForm);



/** WEBPACK FOOTER **
 ** ./src/universal/components/common/mgfForm.js
 **/